export class eSign {
    public _id?: string;  
    public is_active: boolean;
}